// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd1-cls1_99j","cls2":"PodcastLibraryAd1-cls2_ck3 PodcastLibraryAd1-cls1_99j"};